<!--
 * @Author: chengleilei
 * @Date: 2025-09-18 11:13:50
 * @Description: 新增采购单
-->
<template>
    <div>
        <PageHeader title="新增采购单" hidden-breadcrumb>
            <div slot="back" @click="jumpPrevPage">
                <Icon type="md-arrow-back" />
            </div>
        </PageHeader>
        <div class="bg-white mb-40">
            <Card title="采购信息" :bordered="false" dis-hover class="ivu-mt">
                <Form :label-width="100" label-colon ref="formRef" :model="formData" :rules="formRule">
                    <FormItem label="品牌商" prop="brandingCompanyId">
                        <Select
                            placeholder="请选择"
                            v-model="formData.brandingCompanyId"
                            :loading="loadings.brandingCompanyLoading"
                            style="width: 500px"
                        >
                            <Option v-for="option in brandingCompanyOptions" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="收货地址" prop="addressId">
                        <Select
                            v-model="formData.addressId"
                            filterable
                            clearable
                            label-in-value
                            filter-by-label
                            @on-query-change="addressQueryChange"
                            :remote-method="remoteM"
                            :loading="loadings.addressLoading"
                            style="width: 500px"
                            placeholder="请选择"
                        >
                            <Option
                                v-for="option in addressOptions"
                                :value="option.id"
                                :key="option.id"
                                :label="option.label"
                            >
                                {{ option.label }}
                            </Option>
                        </Select>
                        <Button class="ml-20" @click="onAddressAdd">新增</Button>
                        <Button class="ml-4" @click="onAddressManage">管理</Button>
                    </FormItem>
                    <FormItem label="备注" prop="remark">
                        <Input
                            type="textarea"
                            :rows="3"
                            show-word-limit
                            v-model="formData.remark"
                            maxlength="200"
                            placeholder="请输入"
                            style="width: 500px"
                        />
                    </FormItem>
                </Form>
            </Card>
            <Card title="采购商品" :bordered="false" dis-hover class="ivu-mt">
                <ProcureGoods ref="procureGoodsRef" :brandingCompanyId="formData.brandingCompanyId" />
            </Card>
        </div>
        <FooterToolbar>
            <Button class="ml" @click="jumpPrevPage">取消</Button>
            <Button type="primary" class="ml" @click="onSave" :loading="loadings.btnLoading">提交</Button>
        </FooterToolbar>
        <AddressAddModal ref="addressAddModalRef" @success="onAddSuccess" />
        <AddressManageModal ref="addressManageModalRef" @onDelete="onDelete" />
    </div>
</template>
<script>
import { jumpPage, transPathToName } from '@/libs/util';
import { debounce } from 'lodash';
import { apiBrandingCompanyRealtimeList, apiPurchaseAddressList, apiPurchaseOrderSave } from '@/api/purchase';
import AddressAddModal from './components/AddressAddModal';
import AddressManageModal from './components/AddressManageModal';
import ProcureGoods from './components/ProcureGoods';

export default {
    components: { AddressAddModal, AddressManageModal, ProcureGoods },
    data() {
        return {
            formData: { brandingCompanyId: '', addressId: '', remark: '' },
            formRule: {
                brandingCompanyId: [{ required: true, message: '请选择品牌商', trigger: 'change' }],
                addressId: [{ required: true, message: '请选择收货地址', trigger: 'change' }],
            },
            loadings: {
                brandingCompanyLoading: false,
                addressLoading: false,
                btnLoading: false,
            },
            tableConfig: {
                columns: [],
                data: [],
                loading: false,
            },
            brandingCompanyOptions: [], // 品牌商下拉列表
            addressOptions: [], // 地址下拉列表
        };
    },
    mounted() {
        this.getCorrelationCompany();
        this.getAddressOptions(true);
    },
    methods: {
        jumpPrevPage() {
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: '/sub-vue2/purchase/purchaseOrder/list' });
        },
        // 获取品牌商列表（关联的）
        async getCorrelationCompany() {
            this.loadings.brandingCompanyLoading = true;
            try {
                const res = await apiBrandingCompanyRealtimeList();
                this.loadings.brandingCompanyLoading = false;
                this.brandingCompanyOptions = res || [];
                if (res?.length === 1) {
                    this.formData.brandingCompanyId = res[0].id;
                }
            } catch (error) {
                this.brandingCompanyOptionss = [];
                this.loadings.brandingCompanyLoading = false;
            }
        },
        // 地址搜索词change
        addressQueryChange: debounce(function d(val) {
            this.getAddressOptions(false, val);
        }, 300),
        // 获取地址下拉选项
        async getAddressOptions(isFirst, addressStr) {
            this.loadings.addressLoading = true;
            try {
                const res = await apiPurchaseAddressList({ addressStr, current: 1, size: 50 });
                this.loadings.addressLoading = false;
                this.addressOptions = (res.list || []).map((item) => {
                    if (isFirst && item.isDefault) {
                        this.formData.addressId = item.id;
                    }
                    return {
                        label: `${item.address} ${item.name} ${item.mobile}`,
                        ...item,
                    };
                });
            } catch (error) {
                this.loadings.addressLoading = false;
                this.productList = [];
            }
        },
        remoteM() {
            // 为了解决搜索框焦点移出不调用远程搜索方法，将remote-method闲置， 根据on-query-change来调用远程搜索方法
        },
        // 新增收货地地址
        onAddressAdd() {
            this.$refs['addressAddModalRef'].open();
        },
        // 管理收货地址
        onAddressManage() {
            this.$refs['addressManageModalRef'].open();
        },
        // 删除收货地址回调
        onDelete(id) {
            if (id === this.formData.addressId) {
                this.formData.addressId = '';
            }
        },
        // 新增收货地址回调
        async onAddSuccess(id) {
            await this.getAddressOptions();
            this.formData.addressId = id;
        },
        // 提交保存
        onSave() {
            this.$refs['formRef'].validate(async (valid) => {
                if (valid) {
                    const list = this.$refs.procureGoodsRef.getGoodsList();
                    if (!list) return;
                    const params = { ...this.formData, itemList: list };
                    this.loadings.btnLoading = true;
                    try {
                        await apiPurchaseOrderSave(params);
                        this.$Message.success('提交成功');
                        this.jumpPrevPage();
                    } finally {
                        this.loadings.btnLoading = false;
                    }
                }
            });
        },
    },
};
</script>
